import { FormLabel, InputGroup } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";

const ListEditor = (props: IFieldEditor) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) : void => {
    const value = event.target.value;
    props.onValueChange(props.property.Id, value);
  };

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <InputGroup>
        <InputGroupText>
          <FontAwesomeIcon icon={faList} />
        </InputGroupText>
        <textarea
          title="Add items for list, seperated by a line"
          className="form-control"
          rows={10}
          value={props.property.PublishedValue ?? ""}
          onChange={handleChange}
          placeholder="add list items, each item on a new line...">
        </textarea>
      </InputGroup>
    </>
  );
}

export default ListEditor;